import React from 'react';
import { Box, Button, Container, Typography, Link } from '@mui/material';
import ClassificationBannerHeader from '../../common/banner/classifactionBannerHeader';
import PageHeader from '../../common/banner/pageHeader';
import { useNavigate } from 'react-router-dom';
import ComplianceDashboard from '../../common/buttons/complianceDash';

export default function PTVSOverview() {

  const baseRoute = process.env.REACT_APP_BASE_ROUTE || '/';
  const imgRoute = 'images/analytics/nist-1.png';
  const route1 = baseRoute + 'images/analytics/nist-1.png';
  const route2 = baseRoute + 'images/analytics/nist-3.png';
  const navigate = useNavigate();


  const handleResponse = (() => {
    navigate('/nistDetails')
  });
  
  return (
    <Container sx={{ minWidth:1800, mt: 10, mb: 10 }}>
      <Box sx={{pt: 2}}>
        <ClassificationBannerHeader></ClassificationBannerHeader>
        <PageHeader title="CCG Dashboards"></PageHeader>
      </Box>
      <Typography variant='h4' 
        sx ={{display: 'flex', 
              alignItems: 'center', 
              justifyContent: 'center', 
              fontSize: '1.35em', 
              marginBottom: '10px'}}>
        NIST Overview
      </Typography>
      <ComplianceDashboard></ComplianceDashboard>
      <Box
        sx={{          
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          flexDirection: 'column'
        }}
      >
      <img 
          alt="nist 1"
          src={route1}
          width="100%"
          height="100%"
          style={{ border: 'none', display: 'flex', objectFit: 'none', marginTop: '-60px', marginBottom: '-120px' }}
      />
      <img 
          alt="nist 2"
          src={route2}
          width="100%"
          height="100%"
          style={{ border: 'none', display: 'flex', objectFit: 'none', marginBottom: '-140px' }}
      />
      <Button
        onClick={handleResponse}
        sx={{ fontSize: '0.7em',
          marginTop: '90px',
          marginLeft: '560px',
          marginBottom: '-60px',
          color: '#FFF', 
          bgcolor: '#606662' , 
          height: '22px', 
          '&:hover': {
              backgroundColor: '#1f1e1d',
          } }}>
        syslog: User authentication failure
      </Button>
      </Box>
    </Container>
  );
};